export default __webpack_public_path__ + "static/media/ttac1.ccb5354a.svg";